export default __webpack_public_path__ + "components/wind-icon/static/NE@2x-ab0514df177a705077079950a4eb690b.png";